<div toastContainer class="toastr"></div>

<block-ui>
    <router-outlet></router-outlet>
</block-ui>
